import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=101118b1&scoped=true"
import script from "./RegisterModal.vue?vue&type=script&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&lang=ts"
import style0 from "./RegisterModal.vue?vue&type=style&index=0&id=101118b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101118b1",
  null
  
)

export default component.exports